export default __webpack_public_path__ + "static/media/choc-chip.08c4e6be.jpg";